import { render } from "./AgendaPage.vue?vue&type=template&id=9553249a"
import script from "./AgendaPage.vue?vue&type=script&lang=js"
export * from "./AgendaPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__